import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IDashboardStyles {
  root?: IStyle;
}

export interface IDashboardClassNames {
  root: string;
}

export const dashboardStylesDefault = (_theme: IH2OTheme): Partial<IDashboardStyles> => ({
  root: {
    height: '100%',
    overflow: 'auto',
    paddingBottom: '24px',
  },
});
